import React, { useEffect, useState } from 'react';

import { NTTDataUatUrl } from '../../config/urlConfig';
import "./NTTData-form.css";
import loadingGif from "./asset/loading.gif";

export default class NTTDataForm extends React.Component {

  constructor(props) {
    super(props);

    this.state = {  encData: "", merchId: "" }
  }

  componentDidMount() {
    let search = window.location.search;
    let params = new URLSearchParams(search);

    var encData = params.get("encData");

    var merchId = params.get("merchId");

    this.setState({ "encData": encData, "merchId": merchId }, () => {
      setTimeout(()=>{
        // trigger submit to submit form data
        window.history.go(+1);
        document.forms[0].submit();
      },1000);
    });
  }

  render() {
    return (
      <div className="App">
        <form className="submitPayment" action={NTTDataUatUrl} method='POST'>
          <input name='encData' type='hidden' value={this.state.encData} />
          <input name='merchId' type='hidden' value={this.state.merchId} />
          <button type='submit'>Submit</button>
        </form>

        <table className="main-table" width="100%" border="0" cellPadding="0" cellSpacing="1">
          <tbody>
            <tr>
              <td align="center">
                <table width="80%" border="0" cellPadding="1" cellSpacing="0">
                  <tbody>
                    <tr>
                      <td align="center" valign="top" width="100%">
                        <img src={loadingGif} width="100" height="100" />
                      </td>
                    </tr>
                    <tr>
                      <td align="center" valign="middle">
                        <span className="bodytxt4">
                          Processing...
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>

        <table className="main-table" width="100%" border="0" cellPadding="0" cellSpacing="1">
          <tbody>
            <tr>
              <td align="center" valign="top">
                <span className="bodytxt2" >
                  You will be redirected to your merchant's website. It might take a few seconds.
                </span>
              </td>
            </tr>
            <tr>
              <td align="center" valign="top">
                <span className="bodytxt2" >
                  Please do not refresh the page or click the "Back" or "Close" button of your browser.
                </span>
              </td>
            </tr>
          </tbody>
        </table>

        <table className="footer-table" width="100%" height="100%" border="0" cellSpacing="0" cellPadding="0">
          <tbody>
            <tr>
              <td align="center" className="bodytxt2">© Copyrights. All rights reserved. <b>Benepay</b></td>
            </tr>
          </tbody>
        </table>
      </div >
    );
  }
}